export default "__VITE_ASSET__BCY_2cEd__"